import { render } from "./TreeDemo.vue?vue&type=template&id=2e3a0cd9"
import script from "./TreeDemo.vue?vue&type=script&lang=js"
export * from "./TreeDemo.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__